module.exports = __webpack_public_path__ + "static/media/bw.c30048fb.svg";